export const common = {
  nav: {
    about: 'Sobre',
    partners: 'Sócias',
    practice: 'Áreas de Atuação',
    contact: 'Contato',
    language: 'Idioma'
  },
  hero: {
    badge: 'Brasil & Estados Unidos',
    title1: 'Estruturação Regulatória',
    title2: 'Mercado Financeiro',
    title3: 'Expansão Internacional',
    description: 'Transformamos exigências regulatórias em vantagem competitiva para o seu negócio. Segurança jurídica, governança e crescimento sustentável em ambientes regulados.',
    cta1: 'Receba Seu Plano de Ação Estratégico',
    cta2: 'Descubra Como Ajudamos'
  },
  about: {
    badge: 'QUEM SOMOS',
    title: 'Serviços Jurídicos Estratégicos',
    titleItalic: 'Entre Dois Mercados',
    description: 'A Arieira Araujo Advogados atua na interseção entre direito, regulação e estratégia empresarial. Assessoramos empresas que operam ou desejam operar em ambientes regulados, com foco em segurança jurídica, governança e expansão internacional sustentável.',
    approach: 'Nossa atuação é personalizada, técnica e orientada à tomada de decisão estratégica. Não apenas resolvemos problemas jurídicos—construímos vantagens competitivas através da excelência regulatória.',
    positioning: {
      title: 'Estruturados para Empresas que Exigem Excelência',
      description: 'Fomos estruturados para atender empresas que demandam alto nível técnico, segurança jurídica e visão internacional. Nosso compromisso é oferecer soluções jurídicas que não apenas atendam à legislação vigente, mas que também fortaleçam o modelo de negócios e sustentem o crescimento de longo prazo.'
    }
  },
  problems: {
    badge: 'DESAFIOS REAIS, SOLUÇÕES REAIS',
    title: 'Problemas Que',
    titleItalic: 'Realmente Resolvemos',
    description: 'Estas são as questões que tiram o sono de fundadores e executivos. Nós não apenas respondemos—',
    descriptionBold: 'resolvemos com estratégias jurídicas práticas',
    descriptionEnd: 'que protegem seu negócio e impulsionam o crescimento.',
    list: [
      {
        question: 'Como regularizar uma operação de cripto no Brasil sem risco regulatório?',
        solution: 'Desenhamos estruturas conformes que atendem às exigências do Banco Central enquanto protegem seu modelo de negócio'
      },
      {
        question: 'Como estruturar um MSB nos EUA e garantir conformidade total?',
        solution: 'Cuidamos de todo o processo de licenciamento MSB, políticas de governança e conformidade regulatória para que você opere com confiança'
      },
      {
        question: 'Como expandir uma franquia entre Brasil e EUA com segurança jurídica?',
        solution: 'Estruturamos operações de franquia cross-border com COF, contratos e governança que protegem sua marca e receita'
      },
      {
        question: 'Como navegar requisitos de PLD/FT sem desacelerar meu negócio?',
        solution: 'Implementamos programas de compliance simplificados que atendem padrões regulatórios mantendo agilidade operacional'
      },
      {
        question: 'Como estruturar minha empresa para expansão internacional sem armadilhas fiscais ou jurídicas?',
        solution: 'Criamos estruturas societárias cross-border que otimizam governança, minimizam riscos e viabilizam crescimento sustentável'
      },
      {
        question: 'Como transformar conformidade regulatória em vantagem competitiva?',
        solution: 'Transformamos compliance de centro de custo em vantagem estratégica—construindo fundações jurídicas que concorrentes não podem replicar facilmente'
      }
    ],
    cta: {
      title: 'Não Vê Seu Desafio Aqui?',
      description: 'Cada negócio enfrenta obstáculos regulatórios e jurídicos únicos. Vamos discutir sua situação específica e desenhar uma solução que funcione para você.',
      button: 'Fale Conosco Sobre Seu Desafio'
    }
  },
  partners: {
    badge: 'NOSSAS SÓCIAS',
    title: 'Liderança',
    titleItalic: 'Que Entrega Resultados',
    description: 'Nossas sócias combinam profunda expertise regulatória com experiência empresarial real. Elas estruturaram operações complexas cross-border, navegaram desafios regulatórios de alto risco e construíram frameworks jurídicos que viabilizam crescimento sustentável.',
    jessyca: {
      name: 'Jessyca Arieira',
      title: 'Sócia',
      badge1: 'Diretora Jurídica – ABF Rio 2021-2023',
      badge2: 'Especialista em Estruturação Regulatória',
      description: 'Advogada empresarial com atuação especializada em estruturação regulatória, mercado financeiro, criptoativos e expansão internacional. Foi Diretora Jurídica da Associação Brasileira de Franchising – Seccional Rio de Janeiro (ABF Rio) no biênio 2021-2023, posição de destaque no principal órgão representativo do franchising nacional.',
      expertise: 'Expertise',
      expertiseList: [
        'Estruturação regulatória no Brasil',
        'Programas de PLD/FT e compliance',
        'Modelagem societária e governança corporativa',
        'Estruturação de operações com criptoativos',
        'Organização jurídica de franqueadoras e expansão de redes'
      ],
      approach: 'Sua atuação combina técnica regulatória, visão empresarial e experiência prática na estruturação de operações complexas—assessorando fundadores, executivos e conselhos na mitigação de riscos e na consolidação de modelos juridicamente sustentáveis.'
    },
    juliana: {
      name: 'Juliana Araujo',
      title: 'Consultora Estratégica Internacional',
      badge1: 'Formada pela Columbia University com Honras',
      badge2: 'Especialista em Estruturação Internacional',
      description: 'Formada pela Columbia University (Nova York) com distinção acadêmica e honras. Especialista em estruturações empresariais internacionais com profunda expertise em operações cross-border entre Brasil e Estados Unidos.',
      expertise: 'Expertise',
      expertiseList: [
        'Estruturação societária cross-border',
        'Constituição de holdings internacionais',
        'Governança multinacional',
        'Planejamento societário estratégico',
        'Modelagem jurídica para operações Brasil-EUA'
      ],
      approach: 'Sua formação internacional e atuação técnica agregam uma perspectiva alinhada às melhores práticas globais de governança e estruturação empresarial—essencial para empresas que operam entre fronteiras.'
    }
  },
  practice: {
    badge: 'COMO AJUDAMOS',
    title: 'Soluções Que',
    titleItalic: 'Geram Resultados',
    description: 'Somos especializados em transformar complexidade regulatória em vantagem estratégica—ajudando você a operar com confiança em mercados regulados enquanto constrói vantagens competitivas sustentáveis',
    areas: [
      {
        title: 'Estruturação nos Estados Unidos',
        description: 'Entre no mercado americano com fundação jurídica sólida e conformidade regulatória',
        items: [
          'Estruturação societária internacional que protege seus ativos',
          'Licenciamento MSB e compliance para operações financeiras',
          'Frameworks de governança que satisfazem reguladores americanos',
          'Suporte jurídico completo para entrada e expansão no mercado'
        ]
      },
      {
        title: 'Regulação e Mercado Financeiro no Brasil',
        description: 'Navegue o cenário regulatório brasileiro com confiança e vantagem competitiva',
        items: [
          'Operações com cripto estruturadas para conformidade regulatória',
          'Programas de PLD/FT que atendem padrões do Banco Central',
          'Frameworks de governança de riscos que protegem seu negócio',
          'Estratégia regulatória para fintech e serviços financeiros'
        ]
      },
      {
        title: 'Franchising Brasil e EUA',
        description: 'Escale sua rede de franquias entre fronteiras com segurança jurídica',
        items: [
          'Estruturação de franqueadora que viabiliza crescimento sustentável',
          'COF e contratos que protegem sua marca e receita',
          'Governança corporativa para operações multi-unidades',
          'Estratégias de expansão cross-border que minimizam riscos'
        ]
      }
    ],
    differentials: {
      title: 'Nossos Diferenciais',
      list: [
        'Operações Integradas Brasil-EUA',
        'Jurídico + Estratégia Empresarial',
        'Domínio em Mercados Regulados',
        'Prevenção Proativa de Riscos',
        'Atendimento Personalizado'
      ]
    }
  },
  leadForm: {
    badge: 'COMECE AGORA',
    title: 'Receba uma',
    titleItalic: 'Avaliação Preliminar Gratuita',
    description: 'Compartilhe seu desafio e receba uma análise estratégica da nossa equipe. Identificaremos os principais riscos regulatórios e oportunidades específicas para seu negócio.',
    form: {
      name: 'Nome Completo',
      company: 'Empresa',
      interest: 'Área de Interesse',
      interestPlaceholder: 'Selecione uma área',
      interestOptions: [
        'Estruturação EUA & MSB',
        'Regulação Cripto no Brasil',
        'Franchising Brasil-EUA',
        'Compliance PLD/FT',
        'Expansão Internacional',
        'Outro'
      ],
      email: 'Email',
      whatsapp: 'WhatsApp',
      button: 'Solicitar Avaliação Gratuita',
      privacy: 'Suas informações são confidenciais e serão usadas apenas para fornecer a avaliação solicitada.',
      success: 'Solicitação de avaliação recebida! Entraremos em contato em até 24 horas.',
      error: 'Erro ao enviar solicitação. Por favor, tente novamente ou entre em contato via WhatsApp.'
    }
  },
  cta: {
    title1: 'Pronto para Transformar Complexidade Regulatória',
    title2: 'em Vantagem Competitiva?',
    description: 'Receba um plano de ação regulatório customizado para sua expansão internacional. Vamos discutir como podemos eliminar barreiras jurídicas e acelerar seu crescimento.',
    button: 'Receba Seu Plano de Ação Estratégico'
  },
  footer: {
    description: 'Serviços jurídicos estratégicos entre Brasil e Estados Unidos, especializados em estruturação regulatória, mercado financeiro, criptoativos, franchising e operações empresariais internacionais.',
    location: 'Brasil & EUA',
    quickLinks: 'LINKS RÁPIDOS',
    practiceAreas: 'ÁREAS DE ATUAÇÃO',
    areas: [
      'Estruturação Regulatória',
      'Mercado Financeiro',
      'Criptoativos',
      'Franchising',
      'Expansão Internacional'
    ],
    copyright: '2024 Arieira Araujo Advogados. Todos os direitos reservados.',
    poweredBy: 'Powered by Readdy'
  }
};
